$(document).on('click', '.js-accordion-button', (e) => {
  const $target = $(e.currentTarget)
  const $accordion = $target.parents('.js-accordion')
  const $accordionMain = $accordion.find('.js-accordion-content')

  $accordionMain.toggle()
  $accordion.toggleClass('is-open')
})
